import { mergeProps } from '@base-ui/react/merge-props'
import { useRender } from '@base-ui/react/use-render'
import { cn } from '@eigtech/ui/lib/utils'

function Skeleton({ className, render, ...props }: useRender.ComponentProps<'div'>) {
  return useRender({
    defaultTagName: 'div',
    render,
    props: mergeProps<'div'>(
      { className: cn('bg-accent **:opacity-0 animate-pulse rounded-md', className) },
      props
    ),
    state: {
      slot: 'skeleton',
    },
  })
}

export { Skeleton }
